// Translate Name Space.
export const NS = 'QMASUploadDocument';
export const OPTION_RESULT = [
  {
    label: 'Accept',
    value: 'accept',
  },
  {
    label: 'Reject',
    value: 'reject',
  },
  {
    label: 'N/A',
    value: 'na',
  },
];
